import React from 'react';
import Propagator from '../../Propagator';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

const CREATE_USER_MUTATION = gql`
	mutation($data: JSON!) {
		createUser(data: $data) {
			id
			username
			password
			firstName
			lastName
			roles
		}
	}
`;

export default ({ children }) => (
	<Mutation
		mutation={CREATE_USER_MUTATION}
		refetchQueries={['adminQuery', 'appQuery']}
	>
		{createUser => Propagator(children, createUser)}
	</Mutation>
);
